import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BiGridAlt, BiCalendar, BiFile, BiCar, BiWrench, BiUser } from 'react-icons/bi';
import './MobileFooter.css';

const navItems = [
  { id: 'dashboard',    icon: BiGridAlt,  label: 'Tableau',      path: '/dashboard' },
  { id: 'clients',      icon: BiUser,     label: 'Clients',      path: '/clients' },
  { id: 'reservations', icon: BiFile,     label: 'Contrats',     path: '/contracts', primary: true },
  { id: 'fleet',        icon: BiCar,      label: 'Flotte',       path: '/voitures' },
  { id: 'planning',     icon: BiCalendar, label: 'Planning',     path: '/planning' },
  { id: 'entretiens',   icon: BiWrench,   label: 'Entretiens',   path: '/entretiens' },
];

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item) =>
    location.pathname === item.path ||
    (item.id === 'reservations' && location.pathname === '/contracts');

  const handleTabClick = (item) => {
    if (navigator.vibrate) navigator.vibrate(10);
    navigate(item.path);
  };

  return (
    <nav className="mob-pill" dir="ltr">
      {navItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item);
        return (
          <button
            key={item.id}
            className={`mob-pill__item${active ? ' active' : ''}${item.primary ? ' primary' : ''}`}
            onClick={() => handleTabClick(item)}
            aria-label={item.label}
          >
            {active && <span className="mob-pill__indicator" />}
            <Icon className="mob-pill__icon" />
            <span className="mob-pill__label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default Footer;
